import { MedicalTab, medicalTabs } from "../tabs/tabs";

export const isMedicalTabKey = (key: string) => {
  const keyParsed = key.split('-');
  if (keyParsed.length != 2) {
    return false
  }
  const [op , tab] = keyParsed;
  return medicalTabs.includes(tab as (MedicalTab ))
}
